// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"cb409007","952":"1fb69c3b"}[chunkId] + ".chunk.js";
};